export { default } from './toImmutableSeq'
